import { atom } from 'jotai';
import { fetchUserId } from '../../hooks/useFetchUserId';

export const userIdAtom = atom(async () => {
    const userId = await fetchUserId();
    return userId;
});
// import { atomWithStorage } from 'jotai/utils';
// import { fetchUserId } from '../../hooks/useFetchUserId';

// export const userIdAtom = atomWithStorage('userId', fetchUserId);